// extracted by mini-css-extract-plugin
export default {"container":"CustomerInformationSection_container__J2-X-"};